import React from "react";
import { Mail } from "lucide-react";
import Seo from "@/components/Seo";
import ContactForm from "@/components/forms/ContactForm";
import { useLang } from "@/i18n/LangContext";

const CONTENT = {
  nl: {
    seo: { title: "Contact — Lemmer Leeft", description: "Vragen, ideeën of samenwerking? Neem contact op met Lemmer Leeft (BIZ Vereniging Lemmer)." },
    eyebrow: "Contact",
    h1: "Neem contact op",
    intro: "Vragen, ideeën of tips over Lemmer? Laat het ons weten via het formulier of stuur een mail.",
  },
  de: {
    seo: { title: "Kontakt — Lemmer Leeft", description: "Fragen, Ideen oder Kooperationen? Nehmen Sie Kontakt mit Lemmer Leeft (BIZ Vereniging Lemmer) auf." },
    eyebrow: "Kontakt",
    h1: "Kontakt aufnehmen",
    intro: "Fragen, Ideen oder Tipps zu Lemmer? Lassen Sie es uns über das Formular oder per E-Mail wissen.",
  },
  en: {
    seo: { title: "Contact — Lemmer Leeft", description: "Questions, ideas or collaboration? Get in touch with Lemmer Leeft (BIZ Vereniging Lemmer)." },
    eyebrow: "Contact",
    h1: "Get in touch",
    intro: "Questions, ideas or tips about Lemmer? Let us know via the form or by email.",
  },
};

export const ContactPage = () => {
  const { lang } = useLang();
  const c = CONTENT[lang] || CONTENT.nl;

  return (
    <div data-testid="contact-page" className="bg-white">
      <Seo title={c.seo.title} description={c.seo.description} lang={lang} />

      <section className="ll-section-soft py-14 sm:py-20">
        <div className="ll-container max-w-3xl">
          <span className="inline-block text-[#2E9CD6] font-[Poppins] font-semibold text-xs uppercase tracking-[0.2em] mb-3">
            {c.eyebrow}
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">
            {c.h1}
          </h1>
          <div className="flex items-center gap-3 mb-6" aria-hidden="true">
            <span className="block w-10 h-[3px] rounded-full bg-[#2E9CD6]" />
            <svg width="60" height="10" viewBox="0 0 60 10" className="text-[#6BC0E8]">
              <path d="M0,5 C10,0 20,10 30,5 C40,0 50,10 60,5" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" />
            </svg>
          </div>
          <p className="text-[#3E5871] font-[Inter] text-base sm:text-lg leading-relaxed mb-4">
            {c.intro}
          </p>
          <p className="text-[#3E5871] font-[Inter] text-sm inline-flex items-center gap-2 mb-8">
            <Mail className="w-4 h-4 text-[#2E9CD6]" />
            <a
              href="mailto:info@lemmer-leeft.nl"
              className="text-[#2E9CD6] hover:text-[#173A5E] transition font-medium"
              data-testid="mailto-info"
            >
              info@lemmer-leeft.nl
            </a>
          </p>
        </div>
      </section>

      <section className="py-8 sm:py-12">
        <div className="ll-container max-w-3xl">
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
